module.exports = __webpack_public_path__ + "static/1.1.E.1 FORNA RANDARE 1-a25f3fa2cc9f58619556435ddcd64716.jpg";